import React from "react";
import { useI18n } from "hooks/i18n/i18n";
import { Button } from "components/atoms/button/Button";
import { Refference, Ticket } from "@spwn/types/firebase/firestore";
import { enableSkipPurchaseSteps } from "abtest/getABTestGroup";

type Props = {
  isPurchased: boolean;
  isOnSale: boolean;
  isLotteryTicketSellingMode: boolean;
  handleButtonAction: (ticketId: string | undefined) => void;
  handleButtonActionWithVideoTicket: (videoTicket: Ticket & Refference) => void;
  videoTicket: Ticket & Refference;
};
export const TicketPurchaseButton: React.FC<Props> = (props) => {
  const { t } = useI18n();
  const {
    isPurchased,
    isOnSale,
    isLotteryTicketSellingMode,
    handleButtonAction,
    handleButtonActionWithVideoTicket,
    videoTicket,
  } = props;

  // 購入済み
  if (isPurchased)
    return <Button text={t("event.archiveVideo.purchased")} disabled={true} />;
  // 販売期間外
  if (!isOnSale)
    return (
      <Button
        text={t("event.archiveVideo.outsideSalesPeriod")}
        disabled={true}
      />
    );
  if (isLotteryTicketSellingMode)
    return (
      <Button
        text={t("event.buttons.lotteryPurchase")}
        onClick={() => handleButtonAction(videoTicket._id)}
      />
    );
  if (enableSkipPurchaseSteps(videoTicket.eid)) {
    return (
      <Button
        text={t("event.buttons.buyNow")}
        onClick={() => {
          handleButtonActionWithVideoTicket(videoTicket);
        }}
      />
    );
  } else {
    return (
      <Button
        text={t("event.buttons.purchase")}
        onClick={() => {
          handleButtonAction(videoTicket._id);
        }}
      />
    );
  }
};
